import React from "react";
import { connect } from "react-redux";

import {
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

import Select from 'react-select';

import { Button, Form } from "react-bootstrap";

import { setEnterpriseCallLimits } from "services/redux/actions";
import { loadSOPActionMapStart, setSOPCurrentContactStatus } from "services/redux/actions/sop";
import { initiateVoiceCall, setVoiceCallStatus, changeVoiceCallContactDetails } from "services/redux/actions/voiceCalls";

import { getCustomRef } from "services/redux/selectors/groups";

import { Tooltip } from "components/Common/Tooltip/";
import Alert from "components/Common/Alert";

import Icon from "components/Icons/Icon";

import moment from "services/locale/momentInit.js";

import find from "lodash/find";
import isEqual from "lodash/isEqual";

import conxtdOut from "apis/conxtdOut";

import "./Steps.scss";

const contactStatusAvailableOptions = {
  "AN": ["C", "N", "A"],
  "C": ["C", "N", "A"],
  "N": ["C", "N", "A"],
  "A": ["C", "N", "A"],
}

class KeyholderStep extends React.Component {
  state = {
    activeKeyholder: null,
    activeKeyholderIndex: 0,
    isLastKeyholder: false,
    contactStatusFullOptions: [],
    contactStatusDropdownOptions: [],
    selectedContactStatus: null,
    updatingContactStatus: false,
    showPassword: false,
    passwordText: "",
    passwordInputFocus: false,
    passwordVerifying: false,
    passwordVerified: false,
    updatingAction: false,
    movingToNextKeyholder: false,
    escalatingAction: false,
    deEscalatingAction: false,
    device: null, // voice call device
    token: null, // voice call token
  };

  componentDidMount() {
    const { enterprise, sop, step, voiceCalls } = this.props;

    // get the contact status options available to the keyholder
    const contactStatusType = step.type;
    const contactStatusList = sop.contactStatus[contactStatusType];

    const contactStatusFullOptions = [];
    const contactStatusDropdownOptions = [];
    
    for (const property in contactStatusList) {
      contactStatusFullOptions.push({ value: property, label: contactStatusList[property] });
    }

    this.setState({
      contactStatusFullOptions: contactStatusFullOptions,
      contactStatusDropdownOptions : contactStatusDropdownOptions
    });

    // find the current active keyholder for the step
    this.setActiveKeyholder();

    // get the current call limit for voice calls so the use can be informed if they need to top up
    if (voiceCalls) {
      const requestToken = conxtdOut.post(`/TwilioRequest/getCallLimit/${enterprise.id}`);

      requestToken.then((response) => {
        this.props.dispatch(
          setEnterpriseCallLimits({ 
            enterprise_id: enterprise.id,
            call_limits: response.data.call_limits,
          })
        );
      }).catch((error) => {
        console.log("Error on get call limits", error.message);
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { step, keyholdersLoading, currentContactStatus } = this.props;
    const { activeKeyholder, contactStatusFullOptions } = this.state;

    const actionedLogs = (step && step.sop_action)
                            ? step.sop_action.sop_actioned_logs
                            : null;
    const prevActionedLogs = (prevProps.step && prevProps.step.sop_action)
                                ? prevProps.step.sop_action.sop_actioned_logs
                                : null;

    if (
      !isEqual(actionedLogs, prevActionedLogs)
      || (keyholdersLoading === false && prevProps.keyholdersLoading === true)
    ) {
      this.setActiveKeyholder();
    }

    if (activeKeyholder) {
      if (isEqual(activeKeyholder, prevState.activeKeyholder)) { // same keyholder
        if (!isEqual(actionedLogs, prevActionedLogs)) { // but the logs have changed
          this.getCurrentContactStatus();
        }
      } else { // new keyholder
        this.getCurrentContactStatus();

        this.setState({
          passwordVerified: false,
        })
      }
    }

    if (
      currentContactStatus &&
      (!isEqual(currentContactStatus, prevProps.currentContactStatus) ||
      !isEqual(contactStatusFullOptions, prevState.contactStatusFullOptions))
    ) {
      this.setContactStatusDropdownOptions(currentContactStatus.value);
    }
  }

  setContactStatusDropdownOptions(contactStatusCode) {
    const { contactStatusFullOptions } = this.state;

    let contactStatusDropdownOptions = [];
    const availableOptions = contactStatusAvailableOptions[contactStatusCode]
    if (availableOptions) {
      for (let i=0; i<availableOptions.length; i++) {
        const option = find(contactStatusFullOptions, ["value", availableOptions[i]]);
        if (option) {
          contactStatusDropdownOptions.push(option);
        }
      }
    } else {
      contactStatusDropdownOptions = contactStatusFullOptions.slice();
    }

    this.setState({
      contactStatusDropdownOptions: contactStatusDropdownOptions,
    })
  }

  setActiveKeyholder() {
    const { step, keyholders } = this.props;

    let activeKeyholder = null;
    let activeKeyholderIndex = 0;

    if (step.sop_action && step.sop_action.sop_actioned_logs && step.sop_action.sop_actioned_logs.length > 0) {
      // has logs
      const lastLog = step.sop_action.sop_actioned_logs[step.sop_action.sop_actioned_logs.length - 1];
      
      if (lastLog.system_data && keyholders) {
        // last log has system data, which we should be the keyholder data
        keyholders.forEach((keyholder, index) => {
          if (keyholder.id === lastLog.system_data.id) {
            activeKeyholder = keyholder;
            activeKeyholderIndex = index;
          }
        })
      } else if (keyholders && (keyholders.length > 0)) {
        // last log does not have system data, which means it's the final Escalate log,
        // so make the active keyholder the one from the previous log, if there is one.
        // (if there isn't it probably means there are no keyholders because if there were the first one would automatically be put into In Progress)
        // this keyholder will no longer be contactable as the user has moved on to the next step,
        // but the keyholder will be displayed in the greyed-out previous step just so you can see how it was left

        if (step.sop_action.sop_actioned_logs.length >= 2) {
          const secondLastLog = step.sop_action.sop_actioned_logs[step.sop_action.sop_actioned_logs.length - 2];

          keyholders.forEach((keyholder, index) => {
            if (secondLastLog.system_data && (keyholder.id === secondLastLog.system_data.id)) {
              activeKeyholder = keyholder;
              activeKeyholderIndex = index;
            }
          })
        }
      }
    } else if (keyholders && (keyholders.length > 0)) {
      // has no logs, so make the first keyholder the active keyholder
      activeKeyholder = keyholders[0];
      activeKeyholderIndex = 0;
    }

    let isLastKeyholder = false;
    if (!keyholders || (keyholders.length === 0) || (activeKeyholderIndex === keyholders.length-1)) { 
      isLastKeyholder = true;
    }

    this.setState({
      activeKeyholder: activeKeyholder,
      activeKeyholderIndex: activeKeyholderIndex,
      isLastKeyholder: isLastKeyholder,
    });
  }

  getCurrentContactStatus() {
    // - gets the current contact status from the action map and puts it into the redux store for access
    const { step } = this.props;
    const { contactStatusFullOptions, contactStatusDropdownOptions } = this.state;
    const prevContactStatus = this.props.currentContactStatus;

    let currentContactStatus = null;
    let selectedContactStatus = null;

    if (step.sop_action && step.sop_action.sop_actioned_logs && step.sop_action.sop_actioned_logs.length > 0) {
      // has logs
      const lastLog = step.sop_action.sop_actioned_logs[step.sop_action.sop_actioned_logs.length - 1];
      
      if (lastLog.system_data) {
        // it is a keyholder log, so find out what the current contact status is
        const contactStatus = find(contactStatusFullOptions, ['value', lastLog.status]);
        const contactStatusOption = find(contactStatusDropdownOptions, ['value', lastLog.status]);
        if (contactStatus) { currentContactStatus = contactStatus };
        if (contactStatusOption) { selectedContactStatus = contactStatusOption };
      }
    }

    if (!isEqual(currentContactStatus, prevContactStatus)) {
      // put it in the redux store for other components to access without having to extract it from the action map
      this.props.dispatch(
        setSOPCurrentContactStatus({
          currentContactStatus: currentContactStatus,
        })
      );

      this.setState({
        selectedContactStatus: selectedContactStatus,
      });
    }
  }

  handleUpdateContactStatus(event, newContactStatus) {
    if (!this.state.updatingContactStatus) {
      this.setState({
        updatingContactStatus: true,
      });

      const triggerButton = document.getElementById(event.target.id);
      triggerButton.classList.add("cursor-progress");

      this.updateContactStatus(newContactStatus).then(() => {
        this.setState({updatingContactStatus: false });
        triggerButton.classList.remove("cursor-progress");
      }).catch(() => {
        this.setState({updatingContactStatus: false });
        triggerButton.classList.remove("cursor-progress");

        Alert({
          text: "Issue updating status.",
          icon: "warning",
          showConfirmButton: true,
        });
      });
    }
  }

  updateContactStatus(newContactStatus) {
    // handleAmendAction sends an update action request to the backend to change the contact status of the action.
    // handleAmendAction also handles requesting the updated action map data after the update.
    return new Promise(async (resolve, reject) => {
      const { sopActionedEventId, sudoStateId, handleAmendAction } = this.props;
      const { activeKeyholder } = this.state;

      handleAmendAction(
        sopActionedEventId,
        sudoStateId,
        "A",
        newContactStatus,
        activeKeyholder.id,
        "",
        false
      ).then(() => {
        resolve();
      }).catch((error) => {
        reject(error);
      })
    })
  }

  selectedContactStatusChange = (selectedContactStatus) => {
    // - manages the contact status dropdown as a controlled component.
    // changing the status in the dropdown does not automatically change the current contact status of the action.
    // only when the user clicks the button to update does the current contact status of the action change.
    this.setState({
      selectedContactStatus: selectedContactStatus,
    });
  };

  initiateCall(phoneNumber, keyholderUuid, keyholderName, keyholderId, siteName, siteId, customRef) {
    if (phoneNumber !== "") {

      const { enterprise, groupId, sopActionedEventId, sudoStateId } = this.props;
      const { contactStatusDropdownOptions } = this.state;

      let phoneNumberInternational = phoneNumber;
      if (String(phoneNumberInternational[0]) === "0") {
        phoneNumberInternational = "+44" + String(phoneNumberInternational).substring(1);
      }

      // initiateVoiceCall sets the callStatus to "initiate".
      // componentDidUpdate on VoiceCallControls watches for this change in the callStatus,
      // and when that happens it calls makeCall() with the call options.
      // makeCall uses the Twilio device to start the call, and added the "show" class to call-controls-container to show the controls
      this.props.dispatch(
        initiateVoiceCall({ 
          phoneNumber: phoneNumberInternational,
          recordChannel: "record-from-answer-dual",
          keyholderUuid: keyholderUuid,
          keyholderName: keyholderName,
          siteName: siteName,
          siteId: siteId,
          customRef: customRef,
          origin: "sop",
          enterpriseId: enterprise.id,
          groupId: groupId,
          sopActionedEventId: sopActionedEventId,
          sudoStateId: sudoStateId,
          keyholderId: keyholderId,
          makingContactOption: find(contactStatusDropdownOptions, ['value', "P"]) // the contact status options for "Making Contact",
        })
      );
      
    }
  }

  handleMakingContact(event) {
    if (!this.state.updatingContactStatus) {
      this.setState({
        updatingContactStatus: true,
        passwordVerified: false, // reset the password verification
      });

      const makingContactButton = document.getElementById(event.target.id);
      makingContactButton.classList.add("cursor-progress");

      this.updateContactStatus("P").then(() => { // Making contact
        this.setState({updatingContactStatus: false });
        makingContactButton.classList.remove("cursor-progress");
      }).catch(() => {
        this.setState({updatingContactStatus: false });
        makingContactButton.classList.remove("cursor-progress");

        Alert({
          text: "Issue updating status.",
          icon: "warning",
          showConfirmButton: true,
        });
      })
    }
  }

  handleCallDropped(event) {
    if (!this.state.updatingContactStatus) {
      this.setState({
        updatingContactStatus: true,
      });

      const callDroppedButton = document.getElementById(event.target.id);
      callDroppedButton.classList.add("cursor-progress");

      this.callDropped().then(() => {
        this.setState({updatingContactStatus: false });
        callDroppedButton.classList.remove("cursor-progress");
      }).catch(() => {
        this.setState({updatingContactStatus: false });
        callDroppedButton.classList.remove("cursor-progress");

        Alert({
          text: "Issue updating status.",
          icon: "warning",
          showConfirmButton: true,
        });
      })
    }
  }

  callDropped() {
    return new Promise(async (resolve, reject) => {
      const { sopActionedEventId, sudoStateId, currentContactStatus, handleAmendAction } = this.props;
      const { activeKeyholder } = this.state;

      // first, add a comment onto the current contact log to say the call has dropped
      handleAmendAction(
        sopActionedEventId,
        sudoStateId,
        "A",
        currentContactStatus.value,
        activeKeyholder.id,
        "Call dropped",
        true,
      ).then(() => {
        // then, change the contact status back to In Progress
        this.updateContactStatus("IP").then(() => {
          resolve();
        }).catch((error) => {
          reject(error);
        })
      }).catch((error) => {
        reject(error);
      })
    });
  }

  handleVerifyPassword(event) {
    if (!this.state.passwordVerifying) {
      this.setState({ passwordVerifying: true });

      const { enterprise, groupId, sudoStateId } = this.props;

      const verifyButton = document.getElementById(event.target.id);
      verifyButton.classList.add("cursor-progress");

      this.verifyPassword(this.state.passwordText).then((response) => {
        let passwordVerified = false;

        if (response.verified) {
          passwordVerified = true;
          Alert({
            text: "Passcode verified.",
            icon: "success",
            showConfirmButton: true,
            timer: 2000,
          });
        } else {
          passwordVerified = false;
          Alert({
            text: "Passcode not verified.",
            icon: "warning",
            showConfirmButton: true,
            timer: 3000,
          });
        }

        this.setState({
          passwordVerified: passwordVerified,
          passwordVerifying: false,
          passwordText: "",
        });
        this.props.dispatch(
          loadSOPActionMapStart({
            enterprise_id: enterprise.id,
            group_id: groupId,
            sudo_state_id: sudoStateId,
          })
        );

        verifyButton.classList.remove("cursor-progress");

      }).catch((error) => {
        console.log("Error verifying passcode: ", error.message);
        Alert({
          text: "Issue verifying passcode.",
          icon: "warning",
          showConfirmButton: true,
        });

        this.setState({
          passwordVerified: false,
          passwordVerifying: false,
          passwordText: "",
        });
        this.props.dispatch(
          loadSOPActionMapStart({
            enterprise_id: enterprise.id,
            group_id: groupId,
            sudo_state_id: sudoStateId,
          })
        );

        verifyButton.classList.remove("cursor-progress");
      });
    }
  }

  verifyPassword(password) {
    return new Promise(async (resolve) => {
      const { sopActionedEventId } = this.props;
      const { activeKeyholder } = this.state;

      // make the call to verify the passcode
      const verifyResult = conxtdOut.post(`/sop/sop-process/passcode/${sopActionedEventId}/${activeKeyholder.id}`,
        {
          password: password,
        }
      );

      verifyResult.then((response) => {
        resolve({
          verified: true,
        });
      }).catch((error) => {
        resolve({
          verified: false,
          passwordError: error,
        });
      });
    })
  }

  changeCallContactDetails(phoneNumber, keyholderUuid, keyholderName, keyholderId, siteName, siteId, customRef) {
    if (phoneNumber !== "") {

      const { enterprise, groupId, sopActionedEventId, sudoStateId } = this.props;

      let phoneNumberInternational = phoneNumber;
      if (String(phoneNumberInternational[0]) === "0") {
        phoneNumberInternational = "+44" + String(phoneNumberInternational).substring(1);
      }

      this.props.dispatch(
        changeVoiceCallContactDetails({ 
          phoneNumber: phoneNumberInternational,
          recordChannel: "record-from-answer-dual",
          keyholderUuid: keyholderUuid,
          keyholderName: keyholderName,
          siteName: siteName,
          siteId: siteId,
          customRef: customRef,
          origin: "sop",
          enterpriseId: enterprise.id,
          groupId: groupId,
          sopActionedEventId: sopActionedEventId,
          sudoStateId: sudoStateId,
          keyholderId: keyholderId,
        })
      );
      
    }
  }

  handleNextKeyholder(event, commentElementId) {
    if (!this.state.movingToNextKeyholder) {
      this.setState({ movingToNextKeyholder: true });

      const nextKeyholderButton = document.getElementById(event.target.id);
      nextKeyholderButton.classList.add("cursor-progress");

      const commentElement = document.getElementById(commentElementId);

      this.nextKeyholder(commentElement.value).then(() => {
        this.setState({ movingToNextKeyholder: false });

        commentElement.value = "";
        nextKeyholderButton.classList.remove("cursor-progress");

      }).catch((error) => {
        console.log("Error on move to next step: ", error.message);
        Alert({
          text: "Issue updating action. Please try again later.",
          icon: "warning",
          showConfirmButton: true,
        });

        this.setState({ movingToNextKeyholder: false });
        nextKeyholderButton.classList.remove("cursor-progress");
      })
    }
  }

  nextKeyholder(comment) {
    return new Promise(async (resolve, reject) => {

      const { sopActionedEventId, sudoStateId, keyholders, handleAmendAction, site, voiceCalls } = this.props;

      let activeKeyholder = this.state.activeKeyholder;
      let activeKeyholderIndex = this.state.activeKeyholderIndex;
      let isLastKeyholder = false;

      let nextOne = false;
      keyholders.forEach((keyholder, index) => {
        if (nextOne) {
          activeKeyholder = keyholder;
          activeKeyholderIndex = index;
          if (index === keyholders.length-1) {
            isLastKeyholder = true;
          }
          nextOne = false;
        } else if (keyholder.id === activeKeyholder.id) {
          nextOne = true;
        }
      });

      handleAmendAction(
        sopActionedEventId,
        sudoStateId,
        "C",
        "IP",
        activeKeyholder.id,
        comment,
        false
      ).then(() => {

        this.setState({
          activeKeyholder: activeKeyholder,
          activeKeyholderIndex: activeKeyholderIndex,
          isLastKeyholder: isLastKeyholder,
        });

        if (voiceCalls && activeKeyholder && document.getElementById('call-controls-container').classList.contains("show")) {
          this.changeCallContactDetails(
            activeKeyholder.phone,
            activeKeyholder.uuid,
            activeKeyholder.name,
            activeKeyholder.id,
            site.name, 
            site.id,
            (site.id ? getCustomRef(site) : "")
          );
        }

        resolve();

      }).catch((error) => {
        reject(error);
      })
    })
  }

  handleNextStep(event, commentElementId) {
    if (!this.state.escalatingAction) {
      this.setState({ escalatingAction: true });

      const nextStepButton = document.getElementById(event.target.id);
      nextStepButton.disabled = true;
      nextStepButton.classList.add("cursor-progress");

      const commentElement = document.getElementById(commentElementId);

      this.nextStep(commentElement.value).then(() => {
        commentElement.value = "";
        nextStepButton.classList.remove("cursor-progress");
        this.setState({ escalatingAction: false });
      }).catch((error) => {
        console.log("Error on escalate action: ", error.message);
        Alert({
          text: "Issue updating action. Please try again later.",
          icon: "warning",
          showConfirmButton: true,
        });

        this.setState({ escalatingAction: false });
        nextStepButton.classList.remove("cursor-progress");
        nextStepButton.disabled = false;
      })
    }
  }

  nextStep(comment) {
    return new Promise(async (resolve, reject) => {

      const { sopActionedEventId, handleEscalateAction, voiceCalls } = this.props;

      handleEscalateAction(
        sopActionedEventId, 
        comment,
      ).then(() => {

        if (voiceCalls && document.getElementById('call-controls-container').classList.contains("show")) {
          document.getElementById('call-controls-container').classList.remove("show");

          this.props.dispatch(
            setVoiceCallStatus({
              callStatus: "idle"
            })
          );
        }

        resolve();

      }).catch((error) => {
        reject(error);
      })
    })
  }

  handlePreviousStep(event, commentElementId) {
    if (!this.state.deEscalatingAction) {
      this.setState({ deEscalatingAction: true });

      const previousStepButton = document.getElementById(event.target.id);
      previousStepButton.classList.add("cursor-progress");

      const commentElement = document.getElementById(commentElementId);

      this.previousStep( commentElement.value).then(() => {
        commentElement.value = "";
        previousStepButton.classList.remove("cursor-progress");
        this.setState({ deEscalatingAction: false });
      }).catch((error) => {
        console.log("Error on de-escalate action: ", error.message);
        Alert({
          text: "Issue updating action. Please try again later.",
          icon: "warning",
          showConfirmButton: true,
        });

        previousStepButton.classList.remove("cursor-progress");
        this.setState({ deEscalatingAction: false });
      })
    }
  }

  previousStep(comment) {
    return new Promise(async (resolve, reject) => {

      const { sopActionedEventId, handleDeEscalateAction, voiceCalls } = this.props;

      handleDeEscalateAction(
        sopActionedEventId, 
        comment,
      ).then(() => {

        if (voiceCalls && document.getElementById('call-controls-container').classList.contains("show")) {
          document.getElementById('call-controls-container').classList.remove("show");

          this.props.dispatch(
            setVoiceCallStatus({
              callStatus: "idle"
            })
          );
        }

        resolve();

      }).catch((error) => {
        reject(error);
      })
    })
  }

  render() {
    const {
      enterprise,
      site,
      sop,
      sopActionedEventId,
      sudoStateId,
      step,
      stepNumber,
      activeStep,
      closedAction,
      firstStep,
      lastStep,
      isAssignedUser,
      currentContactStatus,
      keyholders,
      keyholdersLoading,
      handleAmendAction,
      voiceCalls,
      callStatus,
      darkMode,
    } = this.props;

    const {
      activeKeyholder,
      activeKeyholderIndex,
      contactStatusDropdownOptions,
      selectedContactStatus,
      updatingContactStatus,
      showPassword,
      passwordText,
      passwordInputFocus,
      passwordVerifying,
      passwordVerified,
    } = this.state;

    const callIcon = (
      <Icon 
        className="fas fa-phone" 
        style={{
          position: "relative",
          right: "4px", 
          bottom: "4px",
        }}
      />
    );

    const { call_limits } = enterprise;

    let callLimitWarning = null;

    if (call_limits === null) {
      callLimitWarning = <div className={`row my-1 py-1 ${activeStep ? "bg-warning" : "bg-muted"} text-white justify-content-center sop-keyholder-message`}>Call feature setup required</div>
    } else if (call_limits === 90) {
      callLimitWarning = <div className={`row my-1 py-1 ${activeStep ? "bg-warning" : "bg-muted"} text-white justify-content-center sop-keyholder-message`}>Call limit at 90% usage</div>
    } else if (call_limits === 100) {
      callLimitWarning = <div className={`row my-1 py-1 ${activeStep ? "bg-danger" : "bg-muted"} text-white justify-content-center sop-keyholder-message`}>Call limit reached, please top up</div>
    };

    return (
      <VerticalTimelineElement
        id={`step-${stepNumber}`}
        className="sop-action-map-timeline-element vertical-timeline-element--work py-4 my-2"
        contentStyle={
          activeStep
            ? darkMode
              ? { border: "1px solid #bbb", backgroundColor: "#0f1f3e" }
              : { border: "1px solid #bbb" }
            : darkMode
              ? { border: "1px solid #bbb", backgroundColor: "#233358" }
              : { border: "1px solid #bbb", backgroundColor: "#eee" }
        }
        contentArrowStyle={{ borderRight: "7px solid #bbb" }}
        icon={<div className="step-number-icon">{stepNumber}</div>}
        iconStyle={{ background: "#2c3e50", marginTop: "2em" }}
      > 
        {/* step title */}
        <h6 className="vertical-timeline-element-title">{(step.code === "C1") ? step.custom_desc : step.step}</h6> 

        {/* step description */}
        {/* <div className="my-1">{step.custom_desc}</div>   */}

        {voiceCalls && callLimitWarning}
        
        {/* logs */}
        {step.sop_action && step.sop_action.sop_actioned_logs && step.sop_action.sop_actioned_logs.length > 0 &&
          <div>
            <div className="mt-2" style={{ fontWeight: "bold", fontSize: "15px" }}>Logs</div>
            {
              step.sop_action.sop_actioned_logs.map((actionedLog, actionedLogIndex) => { // sop_actioned_logs are an array of the top-level logs on the (in this case keyholder) step.
                                                                                         // they will either be the log specifying which keyholder you're working on
                                                                                         // or escalate, de-escalate or takeover.
                                                                                         // the relevant keyholder data is stored in the system_data of the sop_actioned_logs

                const logContactStatusKey = actionedLog.status_key; // e.g. 'default'
                const logContactStatuses = sop.contactStatus[logContactStatusKey];  // the contact status object associated with the contact key,
                                                                                    // e.g. { {IP: 'In Progress}, {CO : 'Complete'} }

                let logText = "";
                if (actionedLog.status === "TO") {
                  logText = actionedLog.system_data ? actionedLog.system_data.msg : ""
                } else {
                  logText = (actionedLog.system_data) // if there is system data, then it's relating to a keyholder
                              ? `${actionedLog.system_data.name} - ${actionedLog.system_data.phone}`
                              : logContactStatuses[actionedLog.status] // if no system data, it's probably the Escalate status
                }

                const created = new moment(actionedLog.created);

                return (
                  <div key={actionedLogIndex}>
                    {/* top-level log */}
                    <div 
                      className={`d-flex justify-content-between ${actionedLog.status === "TO" ? "font-weight-bold" : ""}`}
                      style={{borderBottom: "1px solid lightgray"}}
                    >
                      {/* show the text associated with the log - either 'In Progress' or the name of the Keyholder */}
                      <div>{logText}</div>
                      <div 
                        className="text-muted"
                        style={{minWidth: "130px", textAlign: "right"}}
                      >{created.format("HH:mm:ss DD/MM/YYYY")}</div>
                    </div>

                    {!actionedLog.system_data // no system data, so probably just the Escalate status
                      ?
                        // show the associated comments
                        actionedLog.sop_actioned_comments 
                        && actionedLog.sop_actioned_comments.length > 0 
                        && actionedLog.sop_actioned_comments.map((comment, commentIndex) => {

                          const created = new moment(comment.created);

                          let displayComment = comment.comment;
                          try {
                            displayComment = decodeURIComponent(displayComment)
                          } catch (ignore) {};

                          return (
                            <div 
                              key={actionedLogIndex + "-" + commentIndex}
                              className="ml-2 d-flex justify-content-between"
                              style={{borderBottom: "1px solid lightgray"}}
                            >
                              <div>{displayComment}</div>
                              <div 
                                className="text-muted"
                                style={{minWidth: "130px", textAlign: "right"}}
                              >{created.format("HH:mm:ss DD/MM/YYYY")}</div>
                            </div>
                          )
                        })
                      :
                        // system data, so this is relating to a keyholder/contact.
                        // show the contact log status changes
                        actionedLog.sop_contact_logs.map((contactLog, contactLogIndex) => { // sop_contact_logs are an array of the second-level logs,
                                                                                            // e.g. logging the different steps an operator goes through when
                                                                                            // calling a contact
                          const created = new moment(contactLog.created);

                          return (
                            <div key={contactLogIndex}>
                              {/* contact status log */}
                              <div 
                                className="ml-2 d-flex justify-content-between"
                                style={{borderBottom: "1px solid lightgray"}}
                              >
                                {/* show the text associated with the contact status of the log, e.g. 'Making Contact' */}
                                <div>{logContactStatuses && logContactStatuses[contactLog.status]}</div>
                                <div 
                                  className="text-muted"
                                  style={{minWidth: "130px", textAlign: "right"}}
                                >{created.format("HH:mm:ss DD/MM/YYYY")}</div>
                              </div>

                              {/* associated comments */}
                              {contactLog.sop_contact_comments 
                                && contactLog.sop_contact_comments.length > 0 
                                && contactLog.sop_contact_comments.map((comment, commentIndex) => { // sop_contact_comments are an array of the third-level logs,
                                                                                                    // and are the comments an operator can add while they are calling a contact.
                                                                                                    // they are linked to whichever sop_contact_logs item they are on when they make the comment

                                  const created = new moment(comment.created);

                                  let displayComment = comment.comment;
                                  try {
                                    displayComment = decodeURIComponent(displayComment)
                                  } catch (ignore) {};

                                  if (comment.comment) {
                                    return (
                                      <div 
                                        key={contactLogIndex + "-" + commentIndex}
                                        className="ml-4 d-flex justify-content-between"
                                        style={{borderBottom: "1px solid lightgray"}}
                                      >
                                        <div>{displayComment}</div>
                                        <div 
                                          className="text-muted"
                                          style={{minWidth: "130px", textAlign: "right"}}
                                        >{created.format("HH:mm:ss DD/MM/YYYY")}</div>
                                      </div>
                                    )
                                  } else {
                                    return null;
                                  }
                                })}
                            </div>
                          )
                        })  
                    }
                  </div>
                )
              })
            }
            {!closedAction && <hr />}
          </div>
        }

        {
          // form for amending action
          !closedAction && <Form
            onSubmit={async (event) => {
              event.preventDefault();

              if (!this.state.updatingAction && activeKeyholder && !((!event.target.keyholderStatus || event.target.keyholderStatus.value === "") && event.target.comment.value === "")) {
                this.setState({ updatingAction: true });

                const amendActionButton = document.getElementById("sop-amend-action-button" + stepNumber);
                amendActionButton.classList.add("cursor-progress");

                const commentElement = document.getElementById("comment" + stepNumber);

                handleAmendAction(
                  sopActionedEventId,
                  sudoStateId,
                  "A",
                  step.sop_action.status,
                  activeKeyholder.id,
                  event.target.comment.value,
                  true,
                ).then(() => {

                  commentElement.value = ""; 
                  amendActionButton.classList.remove("cursor-progress");
                  this.setState({ updatingAction: false });

                }).catch((error) => {
                  console.log("Error on amend action: ", error.message);
                  Alert({
                    text: "Issue updating action. Please try again later.",
                    icon: "warning",
                    showConfirmButton: true,
                  });

                  amendActionButton.classList.remove("cursor-progress");
                  this.setState({ updatingAction: false });
                })
              }
            }}
          >

            {/* keyholders */}
            {!keyholdersLoading && keyholders.length === 0 &&
              <div className={`row my-1 py-1 ${activeStep ? "bg-warning" : "bg-muted"} text-white justify-content-center sop-keyholder-message`}>No contacts found</div> 
            }

            {/* call button and contact status buttons */}
            {!keyholdersLoading && activeKeyholder &&
              <div>
                <div className="mt-2 d-flex justify-content-between flex-wrap">
                  <div>Contact {activeKeyholderIndex + 1} of {keyholders.length}</div>
                  <div>Current status: <span className="ml-2 font-weight-bold">{currentContactStatus ? currentContactStatus.label : ""}</span></div>
                </div>
                <div className="d-flex justify-content-between align-items-center flex-wrap" key={stepNumber + "-" + activeKeyholder.id}>
                  <div className="mt-2 d-flex justify-content-start align-items-center">
                    {/* call button */}
                    {voiceCalls && <div className="mr-2 call-button-container">
                      {
                        (activeStep && (callStatus === "idle" || callStatus === "ended") && (call_limits !== 100) && (call_limits !== null))
                          ? <Button
                              className="button-call"
                              variant="success"
                              onClick={() => {
                                this.initiateCall(
                                  activeKeyholder.phone,
                                  activeKeyholder.uuid,
                                  activeKeyholder.name,
                                  activeKeyholder.id,
                                  site.name, 
                                  site.id,
                                  (site.id ? getCustomRef(site) : "")
                                )
                              }}
                            >
                              {callIcon}
                            </Button>
                          : call_limits === 100
                            ?
                              <Tooltip 
                                placement="left"
                                description="Top up required"
                              >
                                <div>
                                  <Button
                                    className="button-call"
                                    variant="success"
                                    style={{pointerEvents: "none"}}
                                    disabled
                                  >
                                    {callIcon}
                                  </Button>
                                </div>
                              </Tooltip>
                            : call_limits === null
                              ?
                                <Tooltip 
                                  placement="left"
                                  description="Setup required"
                                >
                                  <div>
                                    <Button
                                      className="button-call"
                                      variant="success"
                                      style={{pointerEvents: "none"}}
                                      disabled
                                    >
                                      {callIcon}
                                    </Button>
                                  </div>
                                </Tooltip>
                              :
                                <Button
                                  className="button-call"
                                  variant="success"
                                  disabled
                                >
                                  {callIcon}
                                </Button>
                      }
                    </div>}
                    <div>
                      <div>{activeKeyholder.name}</div>
                      <div>{activeKeyholder.phone}</div>
                    </div>
                  </div>
                  {/* contact status buttons */}
                  {
                    currentContactStatus && currentContactStatus.value === "P" // Making contact
                      ? <div style={{ marginLeft: "auto" }}>
                          <Button
                            id={"sop-answered-button" + stepNumber} 
                            className="mr-2 mt-2"
                            variant="success"
                            style={{ width: "7rem" }}
                            disabled={updatingContactStatus}
                            onClick={(event) => {this.handleUpdateContactStatus(event, "AN")}} // Answered
                          >Answered</Button>
                          <Button
                            id={"sop-unanswered-button" + stepNumber} 
                            className="mt-2"
                            variant="warning"
                            style={{ width: "7rem" }}
                            disabled={updatingContactStatus}
                            onClick={(event) => {this.handleUpdateContactStatus(event, "F")}} // Unanswered / engaged
                          >Unanswered</Button>
                        </div>
                      : // Status is Not currently set to Making contact, so do a further check:
                        currentContactStatus
                        && (currentContactStatus.value === "AN" || currentContactStatus.value === "C") // Answered or Made contact - available
                          ? <div style={{ marginLeft: "auto" }}>
                              <Button
                                id={"sop-call-dropped-button" + stepNumber}
                                className=" mt-2"
                                variant="warning"
                                style={{ width: "7.5rem" }}
                                disabled={updatingContactStatus}
                                onClick={(event) => {this.handleCallDropped(event)}}
                              >Call dropped</Button>
                            </div>
                          : // Status is Not currently set to Making contact, Answered or Made contact - available
                            <div className="mt-2" style={{ marginLeft: "auto" }}>
                              <Tooltip
                                description="Sets the status to 'Making Contact'"
                                placement="top"
                              >
                                <div>
                                  <Button
                                    id={"sop-make-contact-button" + stepNumber} 
                                    style={{ width: "7.5rem" }}
                                    disabled={updatingContactStatus || !activeStep}
                                    onClick={(event) => {this.handleMakingContact(event)}} // Making contact
                                  >Make Contact</Button>
                                </div>
                              </Tooltip>
                            </div>
                  }
                </div>
                {/* keyholder passcode */}
                {
                  // check that the keyholder has a passcode
                  // and that the contact status is 'Anwsered' or 'Making contact - available'
                  !keyholdersLoading && activeKeyholder && activeKeyholder.password && !passwordVerified
                  && currentContactStatus && (currentContactStatus.value === "AN" || currentContactStatus.value === "C")
                  && <div className="mt-2 d-flex justify-content-end align-items-center">
                    <span className="font-weight-bold mr-2">Passcode:</span>
                    <div className="d-flex align-items-center mr-2">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        className="text-muted"
                        style={{ borderRight: "none", borderRadius: "0.25rem 0 0 0.25rem", width: "5rem" }}
                        id="contact_password"
                        name="contact_password"
                        autoComplete="new-password"
                        onFocus={() => this.setState({ passwordInputFocus: true })}
                        onBlur={() => this.setState({ passwordInputFocus: false })}
                        value={passwordText}
                        onChange={(e) => {
                          this.setState({
                            passwordText: e.target.value,
                          });
                        }}
                      />
                      <div
                        className="form-control d-flex align-items-center"
                        style={{
                          borderLeft: "none",
                          borderRadius: "0 0.25rem 0.25rem 0",
                          width: "2.5rem",
                          padding: "0.5rem",
                          fontSize: "1rem",
                          borderColor: passwordInputFocus ? "#2c3e50" : "#ced4da",
                        }}
                        onClick={() => {
                          this.setState({
                            showPassword: !showPassword,
                          })
                        }}
                      >
                        <Tooltip
                          description={showPassword ? "Hide passcode" : "Show passcode"}
                          placement="top"
                        >
                          <Icon className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
                        </Tooltip>
                      </div>
                    </div>
                    <Button
                      id={"sop-verify-password-button" + stepNumber} 
                      className="sop-verify-password-button btn-primary"
                      style={{ width: "7.5rem" }}
                      variant="success"
                      disabled={passwordVerifying}
                      onClick={(event) => {this.handleVerifyPassword(event)}}
                      >Verify</Button>
                  </div>
                }
                {/* contact status dropdown */}
                {currentContactStatus
                  && currentContactStatus.value !== "IP" && currentContactStatus.value !== "P" && currentContactStatus.value !== "F"
                  && !(!keyholdersLoading && activeKeyholder && activeKeyholder.password && currentContactStatus.value === "AN" && passwordVerified === false) &&
                    <div className="mb-2 d-flex justify-content-end align-items-center">
                      {/* <div>Select status: </div> */}
                      <div className="d-flex justify-content-end align-items-center flex-wrap">
                        <div className="mt-2">
                          {
                            (contactStatusDropdownOptions.length > 1)
                              // contact status dropdown
                              // if there is more than one available contact status, allow the user to select
                              ? <div style={{ width: "235px" }}>
                                  <Select
                                    id="keyholderStatus"
                                    name="keyholderStatus"
                                    classNamePrefix="sop-contact-status-select"
                                    value={selectedContactStatus}
                                    onChange={(selectedContactStatus) => {
                                      this.selectedContactStatusChange(selectedContactStatus)
                                    }}
                                    options={contactStatusDropdownOptions}
                                    isDisabled={!activeStep}
                                  />
                                </div>
                              : contactStatusDropdownOptions.length === 1 && <div style={{ width: "235px" }}>
                                  <input  
                                    id="keyholderStatus"
                                    type="hidden"
                                    name="keyholderStatus"
                                    value={contactStatusDropdownOptions[0].value}
                                  />
                                </div>
                          }
                        </div>
                        <div className="mt-2 ml-2">
                          <Button
                            id={"sop-set-status-button" + stepNumber} 
                            style={{ width: "7.5rem" }}
                            disabled={updatingContactStatus}
                            onClick={(event) => {
                              if (selectedContactStatus) {
                                this.handleUpdateContactStatus(event, selectedContactStatus.value);
                              }
                            }}
                          >Set Status</Button>
                        </div>
                      </div>
                    </div>
                }
              </div>
            }

            {/* comment box */}
            <textarea
              id={"comment" + stepNumber} 
              name="comment" 
              rows="3"
              className="mt-3 form-control sop-comment"
              style={{width: "100%"}}
              disabled={!activeStep || !isAssignedUser}
            ></textarea>

            {/* amend buttons */}
            <div className="d-flex justify-content-between mt-2">

              {/* next keyholder */}
              {keyholders.length > 0 && 
                <Button 
                  id={"sop-next-keyholder-button" + stepNumber} 
                  className="sop-next-keyholder-button mx-1 btn-primary"  
                  disabled={
                    !activeStep
                    || !isAssignedUser
                    || this.state.isLastKeyholder
                    || this.state.movingToNextKeyholder
                    || !step.sop_action.continue
                    || (voiceCalls && (callStatus === "initiate" || callStatus === "initiated" || callStatus === "accepted"))
                  }
                  onClick={(event) => {this.handleNextKeyholder(event,"comment" + stepNumber )}}
                >Next Contact</Button>
              }

              {/* amend action button */}
              {keyholders.length > 0 && 
                <Button 
                  id={"sop-amend-action-button" + stepNumber} 
                  className="sop-amend-action-button mx-1 btn-primary" 
                  type="submit" 
                  disabled={!activeStep || !isAssignedUser}
                >Add Comment</Button>
              }
            </div>

            <div className="d-flex justify-content-between mt-2">
              {/* de-escalate (previous step) button */}
              <Button 
                id={"sop-previous-step-button" + stepNumber} 
                className={`sop-previous-step-button mx-1 btn-primary ${firstStep && "sop-button-hidden"}`}
                disabled={
                  !activeStep
                  || !isAssignedUser
                  || this.state.deEscalatingAction
                  || (voiceCalls && (callStatus === "initiate" || callStatus === "initiated" || callStatus === "accepted"))
                }
                onClick={(event) => {this.handlePreviousStep(event, "comment" + stepNumber )}}
              >Previous Step</Button>

              {/* escalate (next step) button */}
              <Button 
                id={"sop-next-step-button" + stepNumber} 
                className={`sop-next-step-button mx-1 btn-primary ${lastStep && "sop-button-hidden"}`}
                disabled={
                  !activeStep
                  || !isAssignedUser
                  || this.state.escalatingAction
                  || !step.sop_action.continue
                  || (voiceCalls && (callStatus === "initiate" || callStatus === "initiated" || callStatus === "accepted"))
                }
                onClick={(event) => {this.handleNextStep(event, "comment" + stepNumber )}}
              >Next Step</Button>
            </div>
          </Form>
        }
      </VerticalTimelineElement>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {
    sop: state.sop,
    currentContactStatus: state.sop.currentContactStatus,
    keyholders: state.sites.current.keyholders.data,
    keyholdersLoading: state.sites.current.keyholders.loading,
    callStatus: state.voiceCalls.callStatus,
    darkMode: state.app.darkMode,
  };
};
export default connect(mapStateToProps)(KeyholderStep);